import React, { Component } from 'react';
import { htmlWidget } from '../../Constants'
class Subtitle extends Component {
  render() { 
    if(this.props.text) {
      return <div className={'eir-text eir-subtitle-text' + htmlWidget + (this.props.className ? this.props.className : '')} dangerouslySetInnerHTML={{ __html: this.props.text }} />
    } else {
      return null;
    }
  }
}

export default Subtitle;
